module.exports = __webpack_public_path__ + "static/media/summit.a1e0fe57.png";